import * as THREE from "three";
import { CONFIG } from "../../config";

let sharedTexture: THREE.CanvasTexture | null = null;

function getRiskDotTexture(): THREE.CanvasTexture {
  if (sharedTexture) return sharedTexture;

  const { textureSize } = CONFIG.marker.riskDot;
  const canvas = document.createElement("canvas");
  canvas.width = textureSize;
  canvas.height = textureSize;

  const ctx = canvas.getContext("2d")!;
  const center = textureSize / 2;
  ctx.fillStyle = "#ffffff";
  ctx.beginPath();
  ctx.arc(center, center, center - 1, 0, Math.PI * 2);
  ctx.fill();

  sharedTexture = new THREE.CanvasTexture(canvas);
  sharedTexture.needsUpdate = true;
  return sharedTexture;
}

/** White disc tinted by `color`, so warning and critical can share the texture. */
export function createRiskDotMaterial(color: string): THREE.SpriteMaterial {
  return new THREE.SpriteMaterial({
    map: getRiskDotTexture(),
    color: new THREE.Color(color),
    depthTest: true,
    depthWrite: false,
    transparent: true,
  });
}

export function createRiskDot(material: THREE.SpriteMaterial): THREE.Sprite {
  const sprite = new THREE.Sprite(material);
  const { size, renderOrder } = CONFIG.marker.riskDot;
  sprite.scale.set(size, size, 1);
  sprite.renderOrder = renderOrder;
  return sprite;
}
